var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicketsCommon = function SvgTicketsCommon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.913978 10.7297L10.7297 0.913978C11.2345 0.409208 12.0529 0.409208 12.5577 0.913978L17.6101 5.96641C18.1149 6.47118 18.1149 7.28957 17.6101 7.79434L7.79434 17.6101C7.28957 18.1149 6.47118 18.1149 5.96641 17.6101L0.913978 12.5577C0.409208 12.0529 0.409208 11.2345 0.913978 10.7297Z",
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55397 11.633L7.27397 12.831L7.70997 10.293L5.86597 8.49604L8.41397 8.12604L9.55397 5.81604L10.693 8.12604L13.242 8.49604L11.398 10.293L11.833 12.831L9.55397 11.633Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44175 14.5326L17.4753 7.58598C18.0935 7.22924 18.884 7.44104 19.241 8.05911L22.8175 14.253C23.1746 14.8711 22.9629 15.6616 22.3447 16.0186C22.3446 16.0186 22.3446 16.0187 22.3445 16.0186L10.3109 22.9652C9.69267 23.322 8.90224 23.1102 8.54518 22.4921L4.96867 16.2982C4.61159 15.6801 4.82336 14.8896 5.44155 14.5326C5.4416 14.5326 5.44164 14.5325 5.44175 14.5326Z",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0401 17.454L11.7831 18.641L12.2141 16.127L10.3881 14.347L12.9111 13.981L14.0401 11.694L15.1681 13.981L17.6921 14.347L15.8661 16.127L16.2971 18.641L14.0401 17.454Z",
    fill: "white"
  }))));
};
export default SvgTicketsCommon;